export const PRICING_SUB_TITLE_V2 = "sub_title_v2";
